import _ from 'lodash';

const extractKey = function extractKey(key, data, needsEscaping) {
  let found = data;
  let part = '';

  _.each(key, (char) => {
    if (char === '.') {
      found = found[part];
      part = '';
    } else {
      part += char;
    }
  });

  return needsEscaping ? _.escape(found[part]) : found[part];
};

const getUnescapedKeyFromData = function getUnescapedKeyFromData(key, data) {
  return extractKey(key, data, false);
};

const getKeyFromData = function getKeyFromData(key, data) {
  return extractKey(key, data, true);
};

/**
 * Rendering behaves differently depending on the string context. If it is safe html,
 * treat it as a regular mustache string, escaping `{{`` and leaving `{{{`` unescaped.
 * Otherwise, treat it as an unsafe string that will be escaped later (probably via v-text)
 * if it's being used in an html context. Therefore, don't escape anything here to prevent
 * double escaping later. Unsafe strings use single tags `{` to differentiate them from
 * Mustache-style safe html strings.
 */
const render = function render(string, data, useMustacheStyleInterpolation) {
  if (data === undefined) {
    return string;
  }

  if (string === undefined) {
    return '';
  }

  let view = '';
  let key = '';
  let state = { type: 'root' };
  const delimiter = {
    open: '{',
    close: '}',
  };

  let index = 0;
  while (true) {
    if (string[index] === undefined) {
      break;
    }

    if (state.type === 'root') {
      if (true
        && useMustacheStyleInterpolation
        && string[index] === delimiter.open
        && string[index + 1] === delimiter.open
        && string[index + 2] === delimiter.open
      ) {
        state = { type: 'key', needsEscaping: false };
        index += 3;
      } else if (true
        && useMustacheStyleInterpolation
        && string[index] === delimiter.open
        && string[index + 1] === delimiter.open
      ) {
        state = { type: 'key', needsEscaping: true };
        index += 2;
      } else if (true
        && useMustacheStyleInterpolation === false
        && string[index] === delimiter.open
      ) {
        state = { type: 'key', needsEscaping: false };
        index += 1;
      } else {
        view += string[index];
        index += 1;
      }
    } else if (state.type === 'key') {
      if (true
        && useMustacheStyleInterpolation
        && state.needsEscaping === false
        && string[index] === delimiter.close
        && string[index + 1] === delimiter.close
        && string[index + 2] === delimiter.close
      ) {
        state = { type: 'root' };
        const found = getUnescapedKeyFromData(key, data);
        view += ((found || typeof found === 'number') && found.toString) ? found.toString() : '';
        key = '';
        index += 3;
      } else if (true
        && useMustacheStyleInterpolation
        && state.needsEscaping === true
        && string[index] === delimiter.close
        && string[index + 1] === delimiter.close
      ) {
        state = { type: 'root' };
        const found = getKeyFromData(key, data);
        view += ((found || typeof found === 'number') && found.toString) ? found.toString() : '';
        key = '';
        index += 2;
      } else if (true
        && useMustacheStyleInterpolation === false
        && state.needsEscaping === false
        && string[index] === delimiter.close
      ) {
        state = { type: 'root' };
        const found = getUnescapedKeyFromData(key, data);
        view += ((found || typeof found === 'number') && found.toString) ? found.toString() : '';
        key = '';
        index += 1;
      } else if (string[index] === ' ') {
        index += 1;
      } else {
        key += string[index];
        index += 1;
      }
    }
  }

  return view;
};

export default render;
